/**
 * Seller intake form UI copy and options (Milestone 3).
 */
import {
  SELLER_OWNERSHIP_STATUSES,
  SELLER_PREFERRED_CONTACT_METHODS,
  SELLER_PRIVACY_DEFAULTS,
  SELLER_TYPES,
} from "../../../utils/sellerIntake/sellerIntakeConstants";

export const SELLER_INTAKE_FORM_COPY_ES = Object.freeze({
  sectionTitle: "Envía la información de tu carro",
  sectionIntro:
    "Completa los datos básicos del vehículo y tus datos de contacto. AutoMapa revisará la información antes de preparar una publicación.",
  contactSectionTitle: "Tus datos",
  vehicleSectionTitle: "Datos del vehículo",
  pricingSectionTitle: "Precio y ubicación",
  conditionSectionTitle: "Estado y comentarios",
  consentSectionTitle: "Consentimiento",
  submitLabel: "Enviar mi carro para revisión",
  submitPendingLabel: "Enviando…",
  requiredMarker: "(requerido)",
  conditionPlaceholder:
    "Ejemplo: buen estado general, único dueño, mantenimiento al día, detalles de pintura, llantas nuevas…",
  notesPlaceholder: "Agrega cualquier detalle que ayude a revisar la publicación.",
  photosSectionTitle: "Fotos del vehículo",
  photosSectionHelper:
    "Agrega fotos claras del exterior, interior, tablero y detalles importantes. Las fotos serán revisadas antes de publicarse.",
  photosGuidance: Object.freeze([
    "Frente del vehículo",
    "Parte trasera",
    "Laterales",
    "Interior",
    "Tablero/kilometraje",
    "Detalles o daños visibles",
  ]),
  photosLimitsLabel: "Formatos JPG, PNG o WebP. Máximo 8 MB por foto.",
  photosSelectLabel: "Seleccionar fotos",
  photosCameraLabel: "Tomar foto",
  photosAddingLabel: "Procesando fotos…",
  photosRemoveLabel: "Quitar",
  photosTypeHint:
    "Opcional. Evita subir documentos personales o imágenes con información privada.",
  formSectionSteps: Object.freeze([
    "Tus datos",
    "Datos del vehículo",
    "Precio y ubicación",
    "Estado y comentarios",
    "Consentimiento",
  ]),
  consentLabel:
    "Acepto que AutoMapa use mis datos de contacto y la información del vehículo para revisar esta solicitud y contactarme sobre una posible publicación.",
  consentNote: "Tu información no se publicará automáticamente. Primero será revisada.",
  privacyPolicyLink: "Política de privacidad",
  privacyPolicyHref: SELLER_PRIVACY_DEFAULTS.privacyPolicyHref,
});

export const SELLER_TYPE_OPTIONS = Object.freeze([
  { value: SELLER_TYPES.INDIVIDUAL, label: "Persona vendiendo su carro" },
  { value: SELLER_TYPES.DEALER, label: "Concesionario" },
  { value: SELLER_TYPES.SMALL_LOT, label: "Lote independiente" },
  { value: SELLER_TYPES.UNKNOWN, label: "Otro / no estoy seguro" },
]);

export const SELLER_CONTACT_METHOD_OPTIONS = Object.freeze([
  { value: SELLER_PREFERRED_CONTACT_METHODS.WHATSAPP, label: "WhatsApp" },
  { value: SELLER_PREFERRED_CONTACT_METHODS.PHONE, label: "Llamada" },
  { value: SELLER_PREFERRED_CONTACT_METHODS.EMAIL, label: "Correo" },
  { value: SELLER_PREFERRED_CONTACT_METHODS.ANY, label: "Cualquiera" },
]);

export const SELLER_OWNERSHIP_OPTIONS = Object.freeze([
  { value: SELLER_OWNERSHIP_STATUSES.OWNER, label: "Soy el propietario" },
  { value: SELLER_OWNERSHIP_STATUSES.DEALER_INVENTORY, label: "Inventario de concesionario" },
  { value: SELLER_OWNERSHIP_STATUSES.CONSIGNMENT, label: "Consignación" },
  { value: SELLER_OWNERSHIP_STATUSES.UNKNOWN, label: "No estoy seguro" },
]);

export const SELLER_CURRENCY_OPTIONS = Object.freeze([{ value: "COP", label: "COP — Peso colombiano" }]);
